module.exports = "<alg-face *ngFor=\"let face of faces\"\n  [image]=\"face.image\"\n  [isSelected]=\"value === face.value\"\n  (click)=\"imageSelected(face.value)\">\n</alg-face>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-face-group/alg-face-group.component.html
// module id = ./src/app/components/molecules/alg-face-group/alg-face-group.component.html
// module chunks = main